/**
 * Created by Ram on 22/03/2017.
 */

import React from "react";

class EditAddDevicesToTest extends React.Component {
  render() {
    let allDevices, displayDevices, devicesHead, clustersHead, allClusters;

    let devices = this.props.loadData.devices;
    let clusters = this.props.loadData.clusters;
    let selectedDevices = this.props.loadData.selectedDevices;
    let errorMessage = null,
      success = null,
      serverError = null;

    if (this.props.loadData.error) {
      errorMessage = (
        <div className="alert alert-danger"> {this.props.loadData.error} </div>
      );
    }

    if (this.props.loadData.success) {
      success = (
        <h4 className="alert alert-success col-sm-10 col-sm-offset-1 text-center">
          {this.props.loadData.success}
        </h4>
      );
    }

    if (this.props.loadData.serverError) {
      serverError = (
        <div className="alert alert-danger col-sm-4 col-sm-offset-4 text-center">
          {" "}
          {this.props.loadData.serverError}{" "}
        </div>
      );
    }

    if (devices.length) {
      clustersHead = "";
      allClusters = "";
      devicesHead = (
        <tr>
          <th>Device name</th>
          <th>OS</th>
          <th>OS version</th>
          <th>Model</th>
          <th>Select</th>
        </tr>
      );
      allDevices = devices.map(device => {
        return (
          <tr
            key={device._id}
            className={
              device.trackingDevice == true ? "tracking-device-color" : ""
            }
          >
            <td>{device.name}</td>
            <td>{device.os}</td>
            <td>{device.osVersion}</td>
            <td>{device.model}</td>
            <td>
              <input
                type="checkbox"
                className="pointer-cursor"
                onClick={() => this.props.updateDeviceList(device._id)}
              />
            </td>
          </tr>
        );
      });
    }

    if (clusters.length > 0) {
      devicesHead = "";
      allDevices = "";
      clustersHead = (
        <tr>
          <th>Cluster name</th>
          <th>No.of Devices</th>
          <th>Select</th>
        </tr>
      );
      allClusters = clusters.map(cluster => {
        return (
          <tr key={cluster._id}>
            <td>{cluster.name}</td>
            <td>{cluster.devices.length}</td>
            <td>
              <input
                type="checkbox"
                className="pointer-cursor"
                onClick={() => this.props.getClusterDevices(cluster)}
              />
            </td>
          </tr>
        );
      });
    }

    if (selectedDevices.length) {
      displayDevices = selectedDevices.map(selectedDevice => {
        return (
          <tr key={selectedDevice._id}>
            <td>{selectedDevice.name}</td>
            <td>{selectedDevice.os}</td>
            <td>{selectedDevice.osVersion}</td>
            <td>{selectedDevice.model}</td>
            <td>{selectedDevice.deviceType}</td>
            <td>
              <a
                className="remove-device-cluster"
                onClick={() => this.props.removeDevice(selectedDevice._id)}
              >
                Remove
              </a>
            </td>
          </tr>
        );
      });
    }

    return (
      <div className="centralContent">
        <ol className="breadcrumb">
          <li>
            <a onClick={this.props.navigator.requestTestInstanceManagement}>
              Test Instance Management
            </a>
          </li>
          <li>
            <a onClick={this.props.goBack}>Edit Test Instance</a>
          </li>
          <li className="active">Add Devices to Edit Test Instance</li>
        </ol>

        <div className="test-devices-main-div pull-left">
          <div className="add-test-devices-div">
            <span className="pull-left">Device list</span>
            <input
              type="search"
              className="form-control test-instance-search pull-right"
              placeholder="Search by Device name, OS or Model"
              onChange={this.props.updateSearchState}
              value={this.props.loadData.search}
            />
          </div>

          <div className="test-instance-devices-button">
            <button
              type="button"
              className="btn btn-info pull-left"
              onClick={this.props.getClusters}
            >
              Cluster List
            </button>
            <button
              type="button"
              className="btn btn-primary pull-right"
              onClick={this.props.getDevices}
            >
              Device List
            </button>
          </div>

          <div className="test-devices-list">
            <table className="table table-striped">
              <thead>
                {devicesHead}
                {clustersHead}
              </thead>
              <tbody>
                {allDevices}
                {allClusters}
              </tbody>
            </table>
          </div>
        </div>

        <div className="test-devices-overview pull-right">
          <div className="add-test-devices-list">
            <h3>Devices on instance</h3>
            {serverError}
            {success}
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Device name</th>
                  <th>OS</th>
                  <th>OS Version</th>
                  <th>Model</th>
                  <th>Device Type</th>
                  <th />
                </tr>
              </thead>
              <tbody>{displayDevices}</tbody>
              {this.props.loadData.selectedDevices == "selectedDevices"
                ? errorMessage
                : ""}
            </table>

            <button
              type="button"
              className="btn btn-primary pull-right mainDivSubmit"
              onClick={this.props.handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    ); //return
  } //render
} //EditAddDevicesToTest

export default EditAddDevicesToTest;
